<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import formInput from "@/mixins/shared/formInput";

export default {
	mixins: [formInput],
	components: {Radio, FormGroup},
	props: {
		label: {
			type: String
		}
	}
}
</script>

<template>
	<FormGroup groupClasses="align-items-top">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label && label">
			{{ label }}
		</template>

		<div>
			<div class="d-flex gap-3 col-form-label">
				<Radio @update:modelValue="changeModelValueTo" :model-value="modelValue" :form="form" :name="name" :id="`${this.renderedId}-1`" value="1" label="Ja"/>
				<Radio @update:modelValue="changeModelValueTo" :model-value="modelValue" :form="form" :name="name" :id="`${this.renderedId}-2`" value="0" label="Nee"/>
			</div>
			<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
		</div>
		<div v-if="$slots.descriptionbottom" class="input-description mt-2">
			<slot name="descriptionbottom" />
		</div>

	</FormGroup>
</template>